import React from 'react'
import group from '../../../assets/images/empresa/Group.png'
import groupMobile from '../../../assets/images/empresa/GroupMobile.png'
import Text from '../textStyleDefault/texto'

interface FraseDestacadaProps {
  texto: React.ReactNode // Cambiado de string a React.ReactNode
  textClassName?: string
}

const FraseDestacada = ({
  texto,
  textClassName = ''
}: FraseDestacadaProps): any => {
  return (
    <div className='relative w-screen py-[100px] bg-[#043873] flex items-center justify-center overflow-visible my-16'>
      <picture>
        <source media="(max-width: 767px)" srcSet={groupMobile} />
        <img
          className='absolute -translate-y-[75%] md:-translate-y-[70%] left-0 z-0 opacity-20 h-auto w-[262px]'
          src={group}
          alt="decoración"
        />
      </picture>
      <Text
        variant='destacado'
        className={`text-white text-[16px] md:text-[36px] font-[400] tracking-[0.15%] md:tracking-[0.25%] leading-[125%] md:w-[59%] w-[85%] ${textClassName}`}
      >
        {texto}
      </Text>
    </div>
  )
}

export default FraseDestacada
